import React, { useContext, useState } from 'react';
import { useScopedTranslation } from '../../../../../../application/localization/useScopedTranslation.ts';
import { ButtonColor } from '../../../../../../components/uikit/buttons/Button.tsx';
import { CustomModal } from '../../../../../../components/uikit/modal/CustomModal.tsx';
import styles from './toolbar.module.scss';
import clsx from 'clsx';
import formStyles from '../../../../../../components/form/form.module.scss';
import { MenuItem, Select } from '@mui/material';
import ArrowDown from 'assets/icons/arrow-down-selector.svg?react';
import { Trans } from 'react-i18next';
import { PageDesignerContext } from '../../../DesignerNewPage.tsx';
import { Language } from '../../../../../../services/api/api-client.types.ts';
import { tDynamic } from '../../../../../../helpers/tDynamic.ts';

type OwnProps = {
  closeModal: () => void;
};

const languages: {
  language: Language;
  translateKey: string;
}[] = [
  {
    language: Language.De,
    translateKey: 'deutsch',
  },
  {
    language: Language.En,
    translateKey: 'english',
  },
  {
    language: Language.Fr,
    translateKey: 'french',
  },
  {
    language: Language.Es,
    translateKey: 'spanish',
  },
];

export const DefaultLanguageModal = (props: OwnProps) => {
  const i18n = useScopedTranslation('Page.PageDesigner');
  const i18nLanguages = useScopedTranslation('Page.LanguageSelector');

  const currentLanguage = (
    i18n.i18n.language.charAt(0).toUpperCase() + i18n.i18n.language.slice(1)
  ).split('-')[0];

  const [iseSelectOpened, setIsSelectOpened] = useState(false);
  const [language, setLanguage] = useState<Language>(
    currentLanguage as Language,
  );

  const { closeModal } = props;

  const pageDesignerContext = useContext(PageDesignerContext);

  return (
    <CustomModal
      isOpen={true}
      onSubmit={() => {
        closeModal();
        pageDesignerContext?.defaultLanguageSubmit(language);
      }}
      onCancel={closeModal}
      cancelButtonText={i18n.t('cancel')}
      submitButtonText={i18n.t('save')}
      titleText={i18n.t('default_language')}
      submitButtonType={ButtonColor.Primary}
      containerClassName={styles.width480}
    >
      <div className={styles.text}>
        <Trans i18nKey="Page.PageDesigner.default_lang_modal_body" />
      </div>
      <div className={styles.greyText}>{i18n.t('default_language')}</div>
      <Select
        open={iseSelectOpened}
        onClick={() => {
          setIsSelectOpened(true);
        }}
        onClose={(e) => {
          e.stopPropagation();
          setIsSelectOpened(false);
        }}
        value={language}
        onChange={(e) => setLanguage(e.target.value as Language)}
        className={clsx(formStyles.select, styles.width432)}
        IconComponent={ArrowDown}
        MenuProps={{
          PaperProps: {
            className: clsx(formStyles.selectBody, styles.width432),
          },
          disableScrollLock: true,
        }}
      >
        {languages.map((language) => (
          <MenuItem key={language.language} value={language.language}>
            {tDynamic(i18nLanguages, language.translateKey)}
          </MenuItem>
        ))}
      </Select>
    </CustomModal>
  );
};
